export default __webpack_public_path__ + "static/media/007-tshirt.43ae3430.svg";